export default "__VITE_ASSET__e0af323d__"